/** Returns the public route while preserving internal city data keys. */
export function cityRoutePath(citySlug: string): string {
  return citySlug === "sandiego" ? "/san-diego" : `/${citySlug}`;
}